import React from "react";

export function CustomersListSkeleton() {
    return (
        <div className="bg-white dark:bg-[#1A1A1A] rounded-3xl border border-[#E5E7EB] dark:border-[#2A2A2A] overflow-hidden shadow-sm">
            <div className="overflow-x-auto">
                <table className="w-full text-left border-collapse">
                    <thead>
                        <tr className="bg-gray-50/50 dark:bg-[#212121] border-b border-[#E5E7EB] dark:border-[#2A2A2A]">
                            {["Customer", "Rentals", "Revenue", "Last Activity", "Status", "Actions"].map((h) => (
                                <th key={h} className="px-6 py-4 text-[11px] font-bold text-[#9CA3AF] uppercase tracking-wider">
                                    {h}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-[#E5E7EB] dark:divide-[#2A2A2A]">
                        {[1, 2, 3, 4, 5].map((i) => (
                            <tr key={i} className="animate-pulse">
                                <td className="px-6 py-4">
                                    <div className="flex items-center gap-3">
                                        <div className="w-10 h-10 rounded-full bg-gray-200 dark:bg-[#262626]"></div>
                                        <div className="space-y-2">
                                            <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-32"></div>
                                            <div className="h-3 bg-gray-100 dark:bg-[#262626] rounded w-48"></div>
                                        </div>
                                    </div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="space-y-1">
                                        <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-8"></div>
                                        <div className="h-3 bg-gray-100 dark:bg-[#262626] rounded w-16"></div>
                                    </div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-20 ml-auto"></div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="h-4 bg-gray-200 dark:bg-[#262626] rounded w-24"></div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="h-6 bg-gray-200 dark:bg-[#262626] rounded-full w-20"></div>
                                </td>
                                <td className="px-6 py-4">
                                    <div className="flex justify-end gap-2">
                                        <div className="w-8 h-8 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                                        <div className="w-8 h-8 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                                        <div className="w-8 h-8 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                                    </div>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <style jsx="true">{`
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .5; }
        }
      `}</style>
        </div>
    );
}

export function CustomerDetailSkeleton() {
    return (
        <div className="p-4 lg:p-8 max-w-[1200px] mx-auto space-y-8 animate-pulse">
            <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex items-center gap-4">
                    <div className="w-10 h-10 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                    <div className="space-y-2">
                        <div className="h-6 bg-gray-200 dark:bg-[#262626] rounded w-48"></div>
                        <div className="h-4 bg-gray-100 dark:bg-[#262626] rounded w-32"></div>
                    </div>
                </div>
                <div className="flex gap-2">
                    <div className="w-32 h-10 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                    <div className="w-32 h-10 bg-gray-200 dark:bg-[#262626] rounded-xl"></div>
                </div>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                <div className="bg-white dark:bg-[#1A1A1A] p-6 rounded-3xl border border-[#E5E7EB] dark:border-[#2A2A2A] h-[300px]"></div>
                <div className="lg:col-span-2 space-y-6">
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
                        {[1, 2, 3, 4].map(i => (
                            <div key={i} className="bg-white dark:bg-[#1A1A1A] h-24 rounded-2xl border border-[#E5E7EB] dark:border-[#2A2A2A]"></div>
                        ))}
                    </div>
                    <div className="h-10 border-b border-[#E5E7EB] dark:border-[#2A2A2A] w-64"></div>
                    <div className="bg-white dark:bg-[#1A1A1A] rounded-3xl border border-[#E5E7EB] dark:border-[#2A2A2A] h-[400px]"></div>
                </div>
            </div>
            <style jsx="true">{`
        .animate-pulse {
          animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
        }
        @keyframes pulse {
          0%, 100% { opacity: 1; }
          50% { opacity: .5; }
        }
      `}</style>
        </div>
    );
}
